export const PLACE_TYPE_COUNTRY = 'country';
export const PLACE_TYPE_STATE = 'state';
export const PLACE_TYPE_COUNTY = 'county';
export const PLACE_TYPE_CITY = 'city';
export const PLACE_TYPE_STREET = 'street';
export const PLACE_TYPE_ADDRESS = 'address';
export const PLACE_TYPE_STORE = 'store_id';
